export function sortCategories<T extends Record<string, any>>(categories: T[] | null | undefined): T[] {
  return (categories ?? [])
    .map((category, index) => ({ category, index }))
    .sort((a, b) => {
      const aOrder = Number(a.category?.['order']);
      const bOrder = Number(b.category?.['order']);
      const aHasOrder = Number.isFinite(aOrder);
      const bHasOrder = Number.isFinite(bOrder);

      if (aHasOrder && bHasOrder && aOrder !== bOrder) {
        return aOrder - bOrder;
      }
      if (aHasOrder !== bHasOrder) {
        return aHasOrder ? -1 : 1;
      }
      return a.index - b.index;
    })
    .map(({ category }) => ({
      ...category,
      children: Array.isArray(category?.['children'])
        ? sortCategories(category['children'])
        : category?.['children'],
    }));
}

export function sortParticipantTypesWithCategories<T extends Record<string, any>>(
  participantTypes: T[] | null | undefined,
): T[] {
  return (participantTypes ?? [])
    .map((participantType, index) => {
      const categories = sortCategories(participantType?.['categories']);
      const firstOrder = Number(categories?.[0]?.['order']);
      return {
        participantType: {
          ...participantType,
          categories,
        },
        index,
        firstOrder,
        hasOrder: Number.isFinite(firstOrder),
      };
    })
    .sort((a, b) => {
      if (a.hasOrder && b.hasOrder && a.firstOrder !== b.firstOrder) {
        return a.firstOrder - b.firstOrder;
      }
      if (a.hasOrder !== b.hasOrder) {
        return a.hasOrder ? -1 : 1;
      }
      return a.index - b.index;
    })
    .map(({ participantType }) => participantType);
}

export function getCategoryDisplayLabel(category: any): string {
  return (
    category?.category_display_label ||
    category?.category_name ||
    category?.category_description ||
    category?.desc ||
    ''
  );
}
